export default {
  en: {
    title: 'Two factor authentication',
    '2fa': 'Two factor authentication',
    '2faDescription': 'adds an extra layer of security to your account, this allows you to prevent access to a third party if your password is compromised or stolen, only you will be able to access it.',
    '2faApps': 'We recommend you to use apps like following:',
    codeMessage: 'If you cannot scan this QR code at this time, use this secret key in your application',
    enterPin: 'Enter the code of 6 digits',
    expiredPin: 'The code is expired, try again.',
    backupCodes: 'Backup codes',
    backupCodesDescription: 'If you lose access to the app, you can use one of the following 10 codes, and each backup code is one-time use.',
    backupCodesAlert: 'Save these codes, you will not be able to access them again later.',
    downloadBackupCodes: 'Download backup codes',
    printBackupCodes: 'Print backup codes',
    rememberHowTo: 'Remember that if you lose access to the rotating keys you can use the backup keys. In case you have lost both, send us a ticket or contact us at',
    disable: {
      title: 'Follow the instructions to disable 2FA',
      warning: 'If you do this you will lose the extra security for your account.',
      alert: 'Remember to remove this account from your app to avoid duplicate accounts if you turn 2FA back on.',
      enterPinOrBackup: 'Enter a PIN or backup code',
      placeholderPin: 'PIN or backup code'
    },
    steps: {
      '1': 'Scan the QR code with the 2FA app',
      '2': 'Save the following backup codes',
    },
  },
  es: {
    title: 'Two factor authentication',
    '2fa': 'Autentificación de doble factor',
    '2faDescription': 'añade una capa extra de seguridad a tu cuenta, esto permite impedir el acceso a un tercero si tu contraseña se ve comprometida o robada, solo tu podrás acceder.',
    '2faApps': 'Te recomendamos utilizar aplicaciones como las siguientes:',
    codeMessage: 'Si en este momento no puedes escanear este código QR utiliza esta clave secreta en tu aplicación',
    enterPin: 'Ingresa el código de 6 dígitos',
    expiredPin: 'El código está expirado, inténtalo de nuevo.',
    backupCodes: 'Códigos de respaldo',
    backupCodesDescription: 'Si pierdes acceso a la aplicación, podrás utilizar alguno de los siguientes 10 códigos, y cada código de respaldo es de un solo uso.',
    backupCodesAlert: 'Guarda estos códigos, no podrás volver a acceder a ellos posteriormente.',
    downloadBackupCodes: 'Descargar códigos de respaldo',
    printBackupCodes: 'Imprimir códigos de respaldo',
    rememberHowTo: 'Recuerda que si pierdes acceso a las claves rotativas podrás usar las claves de respaldo. En caso que hayas perdido ambas, envíanos un ticket o contáctanos a',
    disable: {
      title: 'Follow the instructions to disable 2FA',
      warning: 'Si haces esto perderás la seguridad extra para tu cuenta.',
      alert: 'Recuerda eliminar esta cuenta de tu aplicación para evitar cuentas duplicadas si vuelves a activar 2FA.',
      enterPinOrBackup: 'Ingresa una clave 2FA o código de respaldo.',
      placeholderPin: 'Clave 2FA o de código de respaldo'
    },
    steps: {
      '1': 'Escanea este código QR con tu aplicación',
      '2': 'Guarda los códigos de respaldo',
    },
  },
  fr: {
    title: 'Authentification à deux facteurs',
    '2fa': 'Authentification à deux facteurs',
    '2faDescription': 'Ajoute une couche supplémentaire de sécurité à votre compte, empêchant l\'accès à un tiers si votre mot de passe est compromis ou volé, seul vous pourrez accéder.',
    '2faApps': 'Nous vous recommandons d\'utiliser des applications telles que les suivantes :',
    codeMessage: 'Si vous ne pouvez pas scanner ce code QR pour le moment, utilisez cette clé secrète dans votre application',
    enterPin: 'Entrez le code à 6 chiffres',
    expiredPin: 'Le code est expiré, veuillez réessayer.',
    backupCodes: 'Codes de secours',
    backupCodesDescription: 'Si vous perdez l\'accès à l\'application, vous pourrez utiliser l\'un des 10 codes suivants, et chaque code de secours est à usage unique.',
    backupCodesAlert: 'Conservez ces codes, vous ne pourrez plus y accéder par la suite.',
    downloadBackupCodes: 'Télécharger les codes de secours',
    printBackupCodes: 'Imprimer les codes de secours',
    rememberHowTo: 'Souvenez-vous que si vous perdez l\'accès aux clés rotatives, vous pourrez utiliser les clés de secours. En cas de perte des deux, envoyez-nous un ticket ou contactez-nous à',
    disable: {
      title: 'Suivez les instructions pour désactiver la 2FA',
      warning: 'En faisant cela, vous perdrez la sécurité supplémentaire pour votre compte.',
      alert: 'N\'oubliez pas de supprimer ce compte de votre application pour éviter les doublons si vous réactivez la 2FA.',
      enterPinOrBackup: 'Entrez une clé 2FA ou un code de secours.',
      placeholderPin: 'Clé 2FA ou code de secours'
    },
    steps: {
      '1': 'Scannez ce code QR avec votre application',
      '2': 'Conservez les codes de secours',
    },
}

}
